export const OK = 'check-square-fill';
export const EXCLAMATION = 'exclamation-square-fill';
